<template src='./calendarDetailBox.pug' lang='pug'></template>

<script>
import moment from 'moment'
import language from '../../../../build/language/index'
import { maskThousand, maskThousandNoFixed } from '../../../utils/numberMasker.js'
import { VueTabs, VTab } from 'vue-nav-tabs'
import LoadingPlaceholder from '../../loading/LoadingPlaceholder'
import ButtonPrimary from '../../buttons/buttonPrimary/ButtonPrimary'
import Toogle from '../../buttons/toogle/Toogle'
import BetterInputTag from '../../input/betterInputTag/BetterInputTag'

moment.locale(language.getDatePickerLanguage())

export default {
  name: 'CalendarDetailBox',

  components: {
    VueTabs,
    VTab,
    ButtonPrimary,
    Toogle,
    BetterInputTag
  },

  props: {
    startDate: {
      type: Date,
      required: true
    },
    endDate: {
      type: Date,
      required: true
    },
    conciliacaoData: {
      type: Array,
      required: true
    },
    filteredCategory: {
      type: Object
    },
    setCategory: {
      type: Function,
      required: true,
      default: () => null
    }
  },

  watch: {
    conciliacaoData: {
      handler () {
        this.handleChangeSelection ? this.handleChangeSelection() : null
      },
      deep: true
    },
    startDate: {
      handler () {
        this.handleChangeSelection ? this.handleChangeSelection() : null
      },
      deep: true
    },
    filteredCategory: {
      handler () {
        this.handleChangeSelection ? this.handleChangeSelection() : null
      },
      deep: true
    }
  },

  data () {
    return {
      conciliationSummary: [],
      accountsTable: {
        columns: ['conta', 'situacao', 'valorMovFinan', 'valorMovBanc', 'diferenca'],
        options: {
          columnsClasses: {
            'situacao': 'col-2 limit-char table-cell-center',
            'conta': 'col-2 limit-char table-cell-center',
            'valorMovFinan': 'col-2 limit-char table-cell-rigth',
            'valorMovBanc': 'col-2 limit-char table-cell-rigth',
            'diferenca': 'col-2 limit-char table-cell-rigth'
          },
          headings: {
            situacao: this.$t('calendarioConciliacao.detalhe.situacao'),
            conta: this.$t('contaBancaria.labels.numeroConta'),
            valorMovFinan: this.$t('calendarioConciliacao.detalhe.vlMovFinan'),
            valorMovBanc: this.$t('calendarioConciliacao.detalhe.vlMovBanc'),
            diferenca: this.$t('calendarioConciliacao.detalhe.diferenca')
          },
          templates: {
            situacao: LoadingPlaceholder,
            conta: LoadingPlaceholder,
            valorMovFinan: LoadingPlaceholder,
            valorMovBanc: LoadingPlaceholder,
            diferenca: LoadingPlaceholder
          },
          filterable: [],
          filterByColumn: false,
          sortable: [],
          sortIcon: {
            is: ''
          },
          pagination: { chunk: 5 },
          perPageValues: [],
          perPage: 10,
          texts: {
            count: '',
            noResults: this.$t('dataTable.labels.semResultados')
          }
        },
        data: []
      },
      establishmentsTable: {
        columns: ['estabelecimento', 'situacao', 'valorMovFinan', 'valorMovBanc', 'diferenca'],
        options: {
          columnsClasses: {
            'situacao': 'col-2 limit-char table-cell-center',
            'estabelecimento': 'col-2 limit-char table-cell-center',
            'valorMovFinan': 'col-2 limit-char table-cell-rigth',
            'valorMovBanc': 'col-2 limit-char table-cell-rigth',
            'diferenca': 'col-2 limit-char table-cell-rigth'
          },
          headings: {
            situacao: this.$t('calendarioConciliacao.detalhe.situacao'),
            estabelecimento: this.$t('estabelecimentos.labels.estabelecimento'),
            valorMovFinan: this.$t('calendarioConciliacao.detalhe.vlMovFinan'),
            valorMovBanc: this.$t('calendarioConciliacao.detalhe.vlMovBanc'),
            diferenca: this.$t('calendarioConciliacao.detalhe.diferenca')
          },
          templates: {
            situacao: LoadingPlaceholder,
            estabelecimento: LoadingPlaceholder,
            valorMovFinan: LoadingPlaceholder,
            valorMovBanc: LoadingPlaceholder,
            diferenca: LoadingPlaceholder
          },
          filterable: [],
          filterByColumn: false,
          sortable: [],
          sortIcon: {
            is: ''
          },
          pagination: { chunk: 5 },
          perPageValues: [],
          perPage: 10,
          texts: {
            count: '',
            noResults: this.$t('dataTable.labels.semResultados')
          }
        },
        data: []
      },
      categoriesTable: {
        columns: ['categoria', 'situacao', 'valorMovFinan', 'valorMovBanc', 'diferenca'],
        options: {
          columnsClasses: {
            'situacao': 'col-2 limit-char table-cell-center',
            'categoria': 'col-2 limit-char table-cell-center',
            'valorMovFinan': 'col-2 limit-char table-cell-rigth',
            'valorMovBanc': 'col-2 limit-char table-cell-rigth',
            'diferenca': 'col-2 limit-char table-cell-rigth'
          },
          headings: {
            situacao: this.$t('calendarioConciliacao.detalhe.situacao'),
            categoria: this.$t('planoConciliacao.labels.categoria'),
            valorMovFinan: this.$t('calendarioConciliacao.detalhe.vlMovFinan'),
            valorMovBanc: this.$t('calendarioConciliacao.detalhe.vlMovBanc'),
            diferenca: this.$t('calendarioConciliacao.detalhe.diferenca')
          },
          templates: {
            situacao: LoadingPlaceholder,
            categoria: LoadingPlaceholder,
            valorMovFinan: LoadingPlaceholder,
            valorMovBanc: LoadingPlaceholder,
            diferenca: LoadingPlaceholder
          },
          filterable: [],
          filterByColumn: false,
          sortable: [],
          sortIcon: {
            is: ''
          },
          pagination: { chunk: 5 },
          perPageValues: [],
          perPage: 10,
          texts: {
            count: '',
            noResults: this.$t('dataTable.labels.semResultados')
          }
        },
        data: []
      },
      situationList: [
        {
          id: 'A',
          nome: this.$t('statusConciliacao.aberto'),
          color: '#FFD54F',
          prioridade: 1
        },
        {
          id: 'C',
          nome: this.$t('statusConciliacao.conciliado'),
          color: '#81C784',
          prioridade: 3
        },
        {
          id: 'M',
          nome: this.$t('calendarioConciliacao.detalhe.conciliadoManualmente'),
          color: '#4DB6AC',
          prioridade: 4
        },
        {
          id: 'D',
          nome: this.$t('statusConciliacao.divergente'),
          color: '#E57373',
          prioridade: 2
        },
        {
          id: 'N',
          nome: this.$t('statusConciliacao.naoAplicavel'),
          color: '#7EC1F7',
          prioridade: 5
        },
        {
          id: 'T',
          nome: this.$t('calendarioConciliacao.detalhe.total'),
          color: '#7EC1F7',
          prioridade: 6
        }
      ],
      templatesWhenIsLoaded: {
        conta: (h, row) => row.conta,
        estabelecimento: (h, row) => row.estabelecimento,
        categoria: (h, row) => row.categoria,
        situacao: (h, row) => this.getConciliationLabel(row.situacao),
        valorMovFinan: (h, row) => this.getVlTotal(row.valorMovFinan),
        valorMovBanc: (h, row) => this.getVlTotal(row.valorMovBanc),
        diferenca: (h, row) => this.getVlTotal(Number(row.valorMovBanc - row.valorMovFinan).toFixed(2))
      },
      isPreparingData: true,
      showSummary: true
    }
  },

  computed: {
    getFormatedCurrentDate () {
      let label
      if (moment.utc(this.startDate).startOf('day').isSame(moment.utc(this.endDate).startOf('day'))) {
        label = moment.utc(this.startDate).format('LL')
      } else {
        label = moment.utc(this.startDate).format('LL') + ' ' + this.$t('dateRange.labels.ate') + ' ' + moment.utc(this.endDate).format('LL')
      }
      return label
    },
    isComponentReady () {
      return !this.isPreparingData
    },
    handleChangeSelection () {
      this.isPreparingData = true
      this.generatePeriodSummary()
      this.generateGroupByAccount()
      this.generateGroupByEstablishment()
      this.generateGroupByCategory()
      this.isPreparingData = false
    }
  },

  methods: {
    generatePeriodSummary () {
      this.conciliationSummary = []
      let baseData = this.conciliacaoData.filter((item) => {
        return (this.filteredCategory && this.filteredCategory.id !== '-1' ? this.filteredCategory.nome === item.categoria : true) &&
              moment.utc(item.dataMin).isBetween(moment.utc(this.startDate).startOf('day'), moment.utc(this.endDate).endOf('day'), undefined, '[]')
      })
      let total = {
        situacao: 'T',
        movFinanAmount: 0,
        movBancAmount: 0,
        percent: 100
      }
      baseData.map(item => {
        let summaryIndex = this.conciliationSummary.findIndex(el => el.situacao === item.situacao)

        total.movFinanAmount += item.totalMovFinan
        total.movBancAmount += item.totalExtrato

        if (summaryIndex >= 0) {
          let summary = this.conciliationSummary.at(summaryIndex)
          summary.movFinanAmount += item.totalMovFinan
          summary.movBancAmount += item.totalExtrato
          this.conciliationSummary.splice(summaryIndex, 1, summary)
        } else {
          let summary = {
            situacao: item.situacao,
            movFinanAmount: item.totalMovFinan,
            movBancAmount: item.totalExtrato
          }
          this.conciliationSummary.push(summary)
        }
      })
      if (this.conciliationSummary && this.conciliationSummary.length > 0) {
        this.conciliationSummary.map(item => {
          item.percent = (total.movFinanAmount + total.movBancAmount) !== 0
            ? (100 * (item.movFinanAmount + item.movBancAmount)) / (total.movFinanAmount + total.movBancAmount)
            : 'N/A'
        })
        this.conciliationSummary.push(total)
        this.conciliationSummary.sort((a, b) => this.getPrioridadeByStatus(a.situacao) - this.getPrioridadeByStatus(b.situacao))
      }
    },
    generateGroupBy (field) {
      let groupedBy = []
      let baseData = this.conciliacaoData.filter((item) => {
        return (this.filteredCategory && this.filteredCategory.id !== '-1' ? this.filteredCategory.nome === item.categoria : true) &&
              moment.utc(item.dataMin).isBetween(moment.utc(this.startDate).startOf('day'), moment.utc(this.endDate).endOf('day'), undefined, '[]')
      })
      baseData.map(item => {
        let summaryIndex = groupedBy.findIndex(el => el.situacao === item.situacao && (field ? el[field] === item[field] : true))
        if (summaryIndex >= 0) {
          let summary = groupedBy.at(summaryIndex)
          summary.valorMovFinan += item.totalMovFinan
          summary.valorMovBanc += item.totalExtrato
          groupedBy.splice(summaryIndex, 1, summary)
        } else {
          let summary = {
            situacao: item.situacao,
            conta: item.conta,
            estabelecimento: item.estabelecimento,
            categoria: item.categoria,
            valorMovFinan: item.totalMovFinan,
            valorMovBanc: item.totalExtrato
          }
          groupedBy.push(summary)
        }
      })
      return groupedBy
    },
    generateGroupByAccount () {
      this.accountsTable.data = this.generateGroupBy('conta')
      this.accountsTable.options.templates = this.templatesWhenIsLoaded
    },
    generateGroupByEstablishment () {
      this.establishmentsTable.data = this.generateGroupBy('estabelecimento')
      this.establishmentsTable.options.templates = this.templatesWhenIsLoaded
    },
    generateGroupByCategory () {
      this.categoriesTable.data = this.generateGroupBy('categoria')
      this.categoriesTable.options.templates = this.templatesWhenIsLoaded
    },
    getVlTotal (value) {
      return 'R$ ' + maskThousand(value)
    },
    getConciliationLabel (status) {
      let label = ' - '
      this.situationList.map(item => {
        if (item.id === status) {
          label = item.nome
        }
      })
      return label
    },
    getColorByStatus (status) {
      let label = ' - '
      this.situationList.map(item => {
        if (item.id === status) {
          label = item.color
        }
      })
      return label
    },
    getPrioridadeByStatus (status) {
      let label = -1
      this.situationList.map(item => {
        if (item.id === status) {
          label = item.prioridade
        }
      })
      return label
    },
    formatPercent (value) {
      if (!isNaN(value)) {
        let result = Number(value)
        return maskThousandNoFixed((result % 1 !== 0 ? result.toFixed(2) : result)) + '%'
      }
      return value
    },
    handleToogle (selected) {
      this.showSummary = selected
    }
  }
}
</script>
<style>
.detail-header-center {
  text-align: center;
  padding-top: 15px;
}
.detail-header {
  padding-top: 15px;
}
.detail-title {
  font-family: 'Inter', sans-serif !important;
  text-transform: initial !important;
  font-size: 18px !important;
  color: #1d436a !important;
}
.detail-highlight {
  font-family: 'Inter', sans-serif !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  text-transform: initial !important;
  margin-right: 1vh;
}
.detail-highlight-header {
  font-family: 'Inter', sans-serif !important;
  font-size: 16px !important;
  font-weight: bold !important;
  text-transform: initial !important;
}
.margin-container-96 {
  margin-top: 15px;
  width: 96%;
}
.calendar-data-table-det {
  display: block;
  overflow-x: scroll;
}
.sem-lancamentos {
  font-size: 18px;
  color: rgb(0, 172, 230);
}
.left-bordered-div {
  width: 99%;
  height: 5vh;
  padding-top: 1.1vh;
  margin-bottom: 1vh;
  border-left: 12px solid;
  border-top: 1px solid lightgray;
  border-right: 1px solid lightgray;
  border-bottom: 1px solid lightgray;
  border-radius: 10px;
  align-content: center;
}
.transp-bordered-div {
  width: 99%;
  height: 5vh;
  padding-top: 1.6vh;
  border: 12px solid transparent;
  border-radius: 10px;
  margin-bottom: 10px;
}
.calendar-data-table .table-responsive {
  border-radius: 10px !important;
}

.calendar-data-table {
  font-family: 'Inter', sans-serif !important;
}

.calendar-data-table .table-bordered {
  border: 1px solid #dddddd;
}

.calendar-data-table thead:first-child {
  background-color: #fff;
  color: #000 !important;
  font-weight: bold;
  height: 4vh;
}
.calendar-data-table tbody>tr {
  background-color: #ffffff;
}

.calendar-data-table tbody>tr:hover {
  background-color: #f3f8fe;
}

.calendar-data-table .pagination>.active>a {
  background-color: #1c3b60;
  border-color: #1c3b60;
  color: #fff;
}

.calendar-data-table .pagination>li>a {
  color: #1c3b60;
}

.calendar-data-table .pagination>li:first-child>a {
  color: #1c3b60;
}

.calendar-data-table .pagination>li:last-child>a {
  color: #1c3b60;
}

.calendar-data-table .pagination {
  margin: 5px 0;
}
.table-cell-center {
  height: 4vh;
  text-align: center;
}
.table-cell-rigth {
  height: 4vh;
  text-align: right;
}
.text-rigth {
  text-align: right;
}
</style>
<style  scoped>
.div-tag {
  border-radius: 10px;
  background-color: #0068AB25;
  margin: 15px 0px 15px 15px;
  line-height: 20px;
  padding-left: 1vh;
  width: fit-content;
  height: 2.5vh;
  padding-top: 0.2vh;
}
.div-tag > input {
  outline: 0;
  border: 0;
  background: transparent;
  font-size: 13px;
  margin: 5px;
  min-width: 55px;
}
.div-tag > span {
  color: #1c3b60;
  text-align: center;
}

.div-tag > span > a {
  text-decoration: none;
  color: #1c3b60;
  font-size: 10px;
  font-weight: bold;
  padding: 7px;
  height: 10px;
  vertical-align: top;
}
.padding-icon {
  padding-left: 0.7vh;
  padding-right: 0.7vh;
  color: #0068AB !important;
  cursor: pointer;
}
.icon-info {
  font-size: 15px;
  color: gray;
}
</style>


// WEBPACK FOOTER //
// CalendarDetailBox.vue?4340068d